import { Component, OnInit ,Input } from '@angular/core';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { PlatformLocation } from '@angular/common';

@Component({
  selector: 'sw-single-signon-menus',
  templateUrl: './sw-single-signon-menus.component.html',
  styleUrls: ['./sw-single-signon-menus.component.css']
})
export class SwSingleSignonMenusComponent implements OnInit {
  @Input() opentype = 0; //0默认在当前程序打开，1在新标签页打开
  @Input() width = '15%'
  @Input() hasHeader:boolean = true  //是否有头部，默认有
  @Input() hasBorder:boolean = true  // div.box元素是否有边框
  @Input() title:string = '单点登录'  // 标题
  MenusList:any=[];  //显示的快捷菜单
  initMenusList:any=[];  //请求返回的快捷菜单
  constructor(
    private create:SwCreateModalComponentService,
    private box:SwMassageBoxService,
    private router:Router,
    private http:SwHttpClientService, 
    private jwt: SwJwtService,
    private Location: PlatformLocation,
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.queryUserSystems()
  }

  ///查询用户单点系统
  queryUserSystems(){
    this.http.Get(environment.seekerWebAPI + "swSsoSystem/queryUserSystems").subscribe(data => {
         // console.log(data)
          if(data.code == 200){
            let uriList = data["data"].filter(item=>item.url)  //过滤掉没有uri的
            this.MenusList = uriList 
            this.initMenusList = JSON.parse(JSON.stringify(uriList))
          }
    })
  }

  //点击某个系统,获取token;
  RouterLinek(item) {
     //根据sso系统id获取token
     let token = ''
     this.http.Get(environment.seekerWebAPI + "sso/getTokenBySsoSysId?ssoSysId=" + item.ssoSysId).subscribe(data => {
      //console.log(data)
       if(data.code == 200){
         token = data.data.token
         let urls =item.url+"?token="+token;
         window.open(urls);
       }
     })
  }
 



  
}
